import { Component } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'ds-carousel',
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
  standalone: true,
  imports: [NgbCarouselModule],
})

export class CarouselComponent {
  images = [
    { name: '/assets/dspace/images/fachada.jpg', caption: 'Biblioteca "Alejandro Segovia"' },
    { name: '/assets/dspace/images/hall.jpg', caption: 'Hall - Acceso' },
    { name: '/assets/dspace/images/consulta.jpg', caption: 'Servicio de Internet' },
    { name: '/assets/dspace/images/estanterias.jpg', caption: 'Estanterías' },
    { name: '/assets/dspace/images/ingreso.jpg', caption: 'Ingreso' },
    { name: '/assets/dspace/images/fachada2.jpg', caption: 'Biblioteca "Alejandro Segovia"' },
    { name: '/assets/dspace/images/hall2.jpg', caption: 'Hall - Biblioteca "Alejandro Segovia"' },
    { name: '/assets/dspace/images/museo.jpg', caption: 'Museo' },
    { name: '/assets/dspace/images/internet2.jpg', caption: 'Servicio de Internet' },
    { name: '/assets/dspace/images/internet3.jpg', caption: 'Servicio de Internet' },
  ];
  showCarousel = true;
}
